import type { Cart } from 'types/cart/Cart';

export const normalizePromoCode = (code: string) => code.trim().toUpperCase();

export const getWhitelistSubtotal = (
  cart: Cart | undefined | null,
  whitelist: string[],
) => {
  if (!cart) return 0;

  return cart.lines.reduce(
    (sum, line) =>
      whitelist.includes(line.merchandise.product.handle)
        ? sum + Number(line.cost.subtotalAmount.amount)
        : sum,
    0,
  );
};

export const getProgress = (
  cart: Cart | undefined | null,
  threshold: number,
  whitelist: string[],
) => {
  const whitelistSubtotal = getWhitelistSubtotal(cart, whitelist);
  const remainingAmount = Math.max(0, threshold - whitelistSubtotal);
  const progress = Math.max(0, Math.min(1, whitelistSubtotal / threshold));

  return { progress, remainingAmount };
};

export const hasAnyWhitelistedProduct = (
  cart: Cart | undefined | null,
  whitelist: string[],
) => {
  if (!cart) return false;

  return cart.lines.some((line) =>
    whitelist.includes(line.merchandise.product.handle),
  );
};

export const giftAlreadyInCart = (
  cart: Cart | undefined | null,
  giftProducts: string[],
) => {
  if (!cart) return false;

  return cart.lines.some((line) =>
    giftProducts.includes(line.merchandise.product.handle),
  );
};

export const isPromoCodeActive = (
  cart: Cart | undefined | null,
  codes: string[],
) => {
  if (!cart) return false;

  const normalizedCodes = codes.map(normalizePromoCode);
  return cart.discountCodes.some(
    (d) => normalizedCodes.includes(d.code.toUpperCase()) && d.applicable,
  );
};
